import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  FormHelperText,
  FormControl,
  Grid,
  MenuItem,
  OutlinedInput,
  Select,
  Typography,
  TextField,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { makeStyles } from "@mui/styles";
import React, { useEffect } from "react";

import { useFormik } from 'formik';
import * as yup from 'yup';

import { ReactComponent as AlertRed } from "../../icons/alert-red.svg";

import * as Util from "../../services/global.service";

const CreateDialog = (props) => {
  const { t } = useTranslation()
  const { isCodeUsed } = props
  const language = localStorage.getItem("lang")

  const [typeDropdown, setTypeDropdown] = React.useState([{ name: "Goal", value: "goal" }, { name: "Evaluation", value: "evaluation" }, { name: "Evaluation for Probation", value: "probation" }])

  const validationSchema = yup.object({
    code: yup.string().min(1).required(),
    type: yup.string().min(1).required(),
  });
  const formik = useFormik({
    initialValues: {
      code: "",
      type: ""
    },
    enableReinitialize: true,
    validationSchema: validationSchema,
    onSubmit: () => {
      let data = {
        code: formik.values.code,
        type: formik.values.type,
      }
      props.goNext(data)
    },
  });

  const handleClose = () => {
    props.setValue(false)
    formik.resetForm()
  };

  const handleChangeCode = (e) => {
    formik.setFieldTouched('code', true)
    formik.setFieldValue("code", e.target.value)
  };

  const handleChangeType = (val) => {
    formik.setFieldTouched('type', true)
    formik.setFieldValue("type", val)
  };

  // useEffect(() => {
  //   formik.setFieldValue("code", "")
  //   formik.setFieldValue("type", "")
  // }, [props.open])

  const handleNext = () => {
    formik.setFieldTouched('code', true)
    formik.setFieldTouched('type', true)
    formik.validateForm().then(() => formik.isValid ? formik.submitForm() : null)
  }

  useEffect(() => {
    formik.validateForm()
  }, [formik.values])

  return (
    <React.Fragment>
      <Dialog
        open={props.open}
        onClose={() => handleClose()}
        maxWidth="sm"
        fullWidth={true}
        PaperProps={{ sx: { p: 3 } }}
        aria-labelledby="create-dialog-title"
        aria-describedby="create-dialog-description"
      >
        <DialogTitle sx={{ m: 0, p: "0 0 12px 0" }}>
          <Box
            sx={{
              display: "flex",
              justifyContent: "start",
              alignItems: "center",
              p: 0,
              m: 0,
              width: "100%",
            }}
          >
            <Typography fontSize="24px" fontWeight="600" color="#404349">
              {t("adminWorkflow.dialog.create")}
            </Typography>
            <Typography
              color="#404349"
              style={{ cursor: "pointer" }}
              sx={{ ml: "auto" }}
              onClick={() => handleClose()}
            >
              X
            </Typography>
          </Box>
        </DialogTitle>
        <Divider />
        <DialogContent sx={{ p: 0 }}>
          <DialogContentText
            id="content-dialog-description"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              flexFlow: "column",
            }}
            component="div"
          >
            <Grid container mt={1.5}>
              <Grid item xs={12}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.code")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} mb={0}>
              <Grid item xs={12}>
                <TextField
                  error={Boolean(formik.touched.code && formik.errors.code) || isCodeUsed}
                  id="outlined-basic"
                  placeholder={t("adminWorkflow.dialog.fillTheCode")}
                  value={formik.values.code}
                  onChange={handleChangeCode}
                  variant="outlined"
                  required
                  fullWidth
                  size="small"
                />
              </Grid>
            </Grid>
            { 
              Boolean(formik.touched.code && formik.errors.code) &&
                <Grid container mt={0}>
                  <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
                    <AlertRed />
                    <FormHelperText
                      error={true}
                      sx={{ ml: 1 }}
                    >
                      {t("label.pleaseFillOutThisField")}
                    </FormHelperText>
                  </Grid>
                </Grid> 
            }
            { 
              isCodeUsed &&
                <Grid container mt={0}>
                  <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
                    <AlertRed />
                    <FormHelperText
                      error={true}
                      sx={{ ml: 1 }}
                    >
                      {t("adminWorkflow.dialog.thisCodeIsAlreadyUsed")}
                    </FormHelperText>
                  </Grid>
                </Grid> 
            }
            <Grid container mt={1}>
              <Grid item xs={12}>
                <Typography fontSize="18px" fontWeight="500" color="#404349">
                  {t("adminWorkflow.dialog.type")} <span style={{ color: "#CC6058", fontWeight: "600" }}>*</span>
                </Typography>
              </Grid>
            </Grid>
            <Grid container mt={0.5} mb={0}>
              <Grid item xs={12}>
                <FormControl fullWidth>
                  <Select
                    className="custom-placeholder"
                    displayEmpty
                    error={Boolean(formik.touched.type && formik.errors.type)}
                    labelId="type"
                    id="type"
                    input={<OutlinedInput size="small"/>}
                    value={formik.values.type}
                    renderValue={
                      formik.values.type !== "" ? undefined : () => <Typography fontSize="16px" fontWeight="300" color="#AAAAAA">{t("adminWorkflow.label.selectTheType")}</Typography>
                    }
                  >
                    {typeDropdown.map((option, idx) => {
                      return <MenuItem key={idx} value={option.value} onClick={() => handleChangeType(option.value)}><Typography fontWeight="400" fontSize='16px' color='#404349'>{option.name}</Typography></MenuItem>
                    })}
                  </Select>
                </FormControl>
              </Grid>
            </Grid>
            { Boolean(formik.touched.type && formik.errors.type) &&
            <Grid container mt={0}>
              <Grid item xs={12} display="flex" justifyContent="start" alignItems="center">
                <AlertRed />
                <FormHelperText
                  error={true}
                  sx={{ ml: 1 }}
                >
                  {t("label.pleaseFillOutThisField")}
                </FormHelperText>
              </Grid>
            </Grid> }
          </DialogContentText>
        </DialogContent>
        <DialogActions sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', mb: 0, mt: 2 }}>
          <Button onClick={handleNext} size="large" variant="contained" sx={{ minWidth: '144px', width: "fit-content" }} style={{textTransform: 'none'}}>{t(`adminWorkflow.label.next`)}</Button>
        </DialogActions>
      </Dialog>
    </React.Fragment>
  );
};
export default CreateDialog;
